import axios from "axios";
import qs from "qs";
import router from "../../../router";
import utils from "../utils.js";
import {Loading} from 'element-ui';
//export const URL = "http://192.168.1.161:8081/";
// export const URL = "http://192.168.1.194:8081/";
export const URL = "/";
export const BASEURL = URL + "v3xbox/";
export const ADMIN_URL = BASEURL + "sa/";
export const COMMON_DL_URL = BASEURL + "common/dl/";
export const COMMON_FILE_URL = BASEURL + "common/file/";
export const COMMON_DICT_URL = BASEURL + "common/dict/";
export const COMMON_QRCODE_URL = BASEURL + "common/qrCode/";
export const AUTH_URL = BASEURL + "auth/";
// 基础数据部分
export const A_URL = BASEURL + "a/";
// 素材数据部分
export const B_URL = BASEURL + "b/";
// 习题数据部分
export const C_URL = BASEURL + "c/";
// 备课数据部分
export const D_URL = BASEURL + "d/";
// 授课数据部分
export const E_URL = BASEURL + "e/";
//票据流转
export const F_URL = BASEURL + "f/";
//票据流转
export const EXERCISE = BASEURL + "f/";
//授课消息发送
export const WS_URL = BASEURL + "ws/";
// 考试试卷部分
export const EXAM_URL = BASEURL + "exam/";
// khzy任务相关部分
export const KHZY_URL = BASEURL + "common/khzy/";
// 数据统计
export const STATISTICS_URL = BASEURL + "statistics/";
// 数据报告
export const DATAREPORT_URL = BASEURL + "dataReport/";
// 精准复习 数据
export const REVIEW_DATAREPORT_URL = BASEURL + "review/dataReport/";
// 精准复习 数据分析
export const DATA_ANALYSIS = BASEURL + '/mReview/fsjl/';
// 课程管理
export const COURSE_MANAGEMENT = BASEURL + "rCourseIntroduction/";
// 校本资源
export const SCHOOL_RESOURCE_CENTER_URL = BASEURL + "schoolResourceCenter/";
// 精品课
export const BOUTIQUE_COURSE_URL = BASEURL + "boutiqueCourse/";

// 精准复习 - 手动组卷
export const REVIEW_PAPER_URL = BASEURL + "reviewPaper/";

// 4.2精品课
export const J_COURSE_URL = BASEURL + "jcourse/";
//正在请求的url
export const URL_ARRAY = [];
// 结束授课请求url
export const URL_ARRAY_ENDLESSON = [];

//调试url
export const DEBUG_URL = BASEURL + "common/debug/";

export const REVIEW_URL = BASEURL + 'mReview/common/exerBank/'

// 响应时间
axios.defaults.timeout = 300000;
// 配置请求头
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
// 配置接口地址
axios.defaults.baseURL = URL;
// 跨域请求时带上session
axios.defaults.withCredentials = true;

// 请求拦截器
axios.interceptors.response.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.request.use(
  config => {
    //备课需要loading
    let href = window.location.href.substring(
      window.location.href.indexOf("#/") + 2,
      window.location.href.indexOf("#/") + 9
    );
    if (
      href === "dataRep" ||
      href === "d000108" ||
      href === "d000101" ||
      href === "d000207" ||
      href === "d000203" ||
      href === "d000201" ||
      href === "d000305" ||
      href === "exerBan" ||
      href === "examBan" ||
      href === "exam" ||
      href === "exerBas" ||
      href === "viewPap" ||
      href === "c000101" ||
      href === "c000201" ||
      href === "a0003" ||
      href === "f000201" ||
      href === "e000101" ||
      href === "homepag" ||
      window.location.href.substring(
        window.location.href.indexOf("#/") + 2,
        window.location.href.indexOf("#/") + 15
      ) === "panoramicData"
    ) {
      if (
        config.url.indexOf("/dataReport/") > 0 ||
        config.url.indexOf("/d/") > 0 ||
        config.url.indexOf("/e/") > 0 ||
        config.url.indexOf("/w/") > 0 ||
        config.url.indexOf("/exam/") > 0 ||
        config.url.indexOf("/c/") > 0 ||
        config.url.indexOf("/a/") > 0 ||
        config.url.indexOf("/e/") > 0 ||
        config.url.indexOf("/f/") > 0 ||
        config.url.indexOf("/statistics/classData") > 0 ||
        (config.url.indexOf("/statistics/panoramaData") > 0 &&
          !(
            config.url.indexOf("/statistics/panoramaData/getClassActivity") > 0
          ))
      ) {
        URL_ARRAY.push(config.url);
      }
    }
    //保存习题，显示加载
    if (config.url.indexOf("/c0002/updateByKhzy") > 0) {
      URL_ARRAY.push(config.url);
    }

    if (config.url.indexOf("/boutiqueCourse/useCourse") > 0) {
      URL_ARRAY.push(config.url);
    }

    if (config.url.substring(10, 20) == "/endLesson") {
      URL_ARRAY_ENDLESSON.push(config.url);
    }
    //新建主题，显示加载
    if (
      config.url.indexOf("course/jCourseKnowTheme") > 0 &&
      config.method === "post"
    ) {
      URL_ARRAY.push(config.url);
    }
    //添加学生评价，显示加载
    if (config.url.indexOf("evaluation/addEvaluation") > 0) {
      URL_ARRAY.push(config.url);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (
      response.config.url.indexOf("/dataReport/") > 0 ||
      response.config.url.indexOf("/d/") > 0 ||
      response.config.url.indexOf("/c/") > 0 ||
      response.config.url.indexOf("/f/") > 0 ||
      response.config.url.indexOf("/a/") > 0 ||
      response.config.url.indexOf("/exam/") > 0 ||
      response.config.url.indexOf("/w/") > 0 ||
      response.config.url.indexOf("/e/") > 0 ||
      response.config.url.indexOf("/statistics/panoramaData")
    ) {
      for (var i = 0; i <= URL_ARRAY.length; i++) {
        if (URL_ARRAY[i] === response.config.url) {
          URL_ARRAY.splice(i);
        }
      }
    }

    if (response.config.url.substring(10, 20) == "/endLesson") {
      for (var i = 0; i <= URL_ARRAY_ENDLESSON.length; i++) {
        if (URL_ARRAY_ENDLESSON[i] === response.config.url) {
          URL_ARRAY_ENDLESSON.splice(i);
        }
      }
    }
    // 如果返回的状态码为200，说明接口请求成功
    if (response.status === 200) {
      if (!utils.isNull(response.data)) {
        switch (response.data.code) {
          case "20005":
            router.push({
              name: "Login",
              params: {errMsg: response.data.msg}
            });
            return false;
          // case "501":
          //   router.push({ name: '501', params: { errMsg: response.data.msg } });
          //   return false;
          case "20001":
            router.push({
              name: "Login",
              params: {errMsg: response.data.msg}
            });
            return false;
          case "90001":
            router.push({
              name: "NOACCESS",
              params: {errMsg: response.data.msg}
            });
            return false;
          default:
            return response;
        }
      }
      return response;
    } else {
      utils.notifyWarning("请求超时！");
      return Promise.reject(response);
    }
  },
  error => {
    utils.notifyWarning("请求超时！");
    return Promise.reject(error);
  }
);

/**
 * GET方式请求
 */
export function get(url, param) {
  if (typeof param != "undefined" && param != null) {
    url = url + "?" + qs.stringify(param);
  }
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * post方式请求
 * 使用application/x-www-form-urlencoded;charset=UTF-8提交
 */
export function post(url, param, config) {
  config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  };

  if (typeof param != "undefined" && param != null) {
    param = qs.stringify(param);
  }
  return new Promise((resolve, reject) => {
    axios
      .post(url, param, config)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * post
 * 使用application/json;charset=UTF-8提交
 */
export function postByJson(url, param) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, param)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * put request
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
export function put(url, data) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除
 */
export function _delete(url, data) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {data: data})
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 文件下载
 */
export function download(url, param) {
  if (typeof param != "undefined" && param != null) {
    url = url + "?" + qs.stringify(param);
  }
  axios.request({url: url, method: "get", responseType: "blob"}).then(res => {
    if (!res) {
      return;
    }
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = window.URL.createObjectURL(res.data);
    link.setAttribute("download", param.dlName);
    document.body.appendChild(link);
    link.click();
  });
}

export function downloadJCourse(url, param) {
  if (typeof param != "undefined" && param != null) {
    url = url + "?" + qs.stringify(param);
  }
  axios.request({url: url, method: "get", responseType: "blob"}).then(res => {
    if (!res) {
      return;
    }
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = window.URL.createObjectURL(res.data);
    link.setAttribute("download", param.dlName);
    document.body.appendChild(link);
    link.click();
  });
}

/**
 * 下载静态资源（后台静态文件夹下）
 */
export function downloadFile(url, fileName) {
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
}

/**
 * 上传文件
 */
export function upload(url, param) {
  let config = {headers: {"Content-Type": "multipart/form-data;"}};
  return new Promise((resolve, reject) => {
      axios
          .post(url, param, config)
          .then(response => {
              resolve(response.data);
          })
          .catch(error => {
              reject(error);
          });
  });
}

/**
 * 文件下载带Loading
 */
export function downloadLoading(url, param, loadingName = '正在下载中') {
    let loadingInstance = Loading.service({
        lock: true,
        text: loadingName,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
    })
    if (typeof param != "undefined" && param != null) {
        url = url + "?" + qs.stringify(param);
    }
    return new Promise((resolve, reject) => {
        axios.request({url: url, method: "get", responseType: "blob"}).then(res => {
            if (!res) {
                reject(false);
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = window.URL.createObjectURL(res.data);
            link.setAttribute("download", param.dlName);
            document.body.appendChild(link);
            link.click();
            resolve(true);
        }).catch(error => {
            reject(error);
        }).finally(() => {
            loadingInstance.close();
        })
    })
}


export function downloadPaperLoading(url, param) {
  let loadingInstance = Loading.service({
        lock: true,
        text: '正在下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
    })
    if (typeof param != "undefined" && param != null) {
        url = url + "?" + qs.stringify(param);
    }
    return new Promise((resolve, reject) => {
        axios.request({url: url, method: "get", responseType: "blob",headers: {'Accept': 'application/msword'}}).then(res => {
            if (!res) {
                reject(false);
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = window.URL.createObjectURL(res.data);
            link.setAttribute("download", param.dlName);
            document.body.appendChild(link);
            link.click();
            resolve(true);
        }).catch(error => {
            reject(error);
        }).finally(() => {
            loadingInstance.close();
        })
    })
}



// WEBPACK FOOTER //
// ./src/components/tools/request/https.js